import React from "react";
import { Layout } from "antd";
import PropTypes from "prop-types";
import Navbar from "../components/section/Navbar";
import Footer from "../components/section/Footer";
import "./MocoLayout.scss";

const MocoLayout = ({ children, bgColor = "#e4f2ff" }) => {
  const { Content } = Layout;
  return (
    <Layout
      className="layout"
      style={{
        backgroundColor: bgColor,
      }}
    >
      <Navbar />
      <Content className="layout__content">{children}</Content>
      <Footer alter={false} />
    </Layout>
  );
};

MocoLayout.propTypes = {
  children: PropTypes.node.isRequired,
  bgColor: PropTypes.string,
};

export default MocoLayout;
